/* General layout */
pnx-editor {
	display: flex;
	flex-direction: column;
	position: relative;
}

pnx-editor .pnx-map,
pnx-editor .pnx-psv {
	height: 50%;
	position: relative;
}

/* Map background widget */
pnx-editor pnx-map-background {
	position: absolute;
	padding: 7px;
	z-index: 120;
	border-radius: 10px;
	border: 1px solid var(--widget-border-div);
	background-color: var(--widget-bg);
  	color: var(--widget-font);
	bottom: 10px;
	left: 10px;
	font-family: var(--font-family);
}

/* Player widget */
pnx-editor pnx-widget-player {
	margin-top: 10px;
}
pnx-editor pnx-widget-player #pnx-player-play,
pnx-editor pnx-widget-player #pnx-player-play-backward {
	display: none;
}

/* Map scale */
pnx-editor .maplibregl-ctrl-scale {
	position: absolute;
	bottom: 75px;
	left: 0;
	float: unset;
}